import styled from "styled-components";
import { media } from "../../../../utils";

export const ContentPassoAPassoContemplacao = styled.div({
  [media.lg()]: {
    ".DoubleContent__ResizableColumn": {
      alignItems: "flex-start",
    },
  },
});

export default null;
